import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import {
  MatDrawer,
  MatDrawerContainer,
  MatSidenavModule,
} from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import {
  MatButton,
  MatIconButton,
  MatButtonModule,
} from '@angular/material/button';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { NgStyle } from '@angular/common';
import { Menu } from '../../../core/interfaces/menu.interface';
import { LoginService } from '../../../core/services/login.service';
import { TruncatePipe } from '../../../core/pipes/truncate.pipe';
import { MatTooltip } from '@angular/material/tooltip';
import { filter } from 'rxjs';
import { StepByStepModalComponent } from '../step-by-step-modal/step-by-step-modal.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-sidenav',
  standalone: true,
  imports: [
    MatSidenavModule,
    MatIconButton,
    MatButton,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatListModule,
    RouterLink,
    NgStyle,
    TruncatePipe,
    MatTooltip,
  ],
  templateUrl: './sidenav.component.html',
  styleUrl: './sidenav.component.scss',
})
export class SidenavComponent {
  isExpanded = false;
  userName = '';
  showSidenav = true;
  activeRoute = '';
  menus: Menu[] = [];
  showHelp = false;
  constructor(
    private router: Router,
    public loginService: LoginService,
    public dialog: MatDialog
  ) {
    loginService.menus.subscribe((menus) => (this.menus = menus));
    loginService.authToken.subscribe((authToken) => {
      this.userName = authToken?.companyName || '';
      this.showHelp = authToken?.companyType === 'LEAD';
    });
  }
  ngOnInit() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))

      .subscribe((event: NavigationEnd) => {
        this.activeRoute = event.urlAfterRedirects;
      });
  }

  openDialog() {
    this.dialog.open(StepByStepModalComponent, {
      minWidth: '100vw',
    });
  }

  toggleSidenav() {
    this.isExpanded = !this.isExpanded;
  }
}
